import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,   // send session_token cookie for Google auth
});

const TOKEN_KEY = "irollo_crm_token";
export const SCOPE_KEY = "irollo_crm_operatore_scope";

// Use sessionStorage: tighter blast radius than localStorage for XSS (clears on tab close).
// Google OAuth doesn't rely on this — it uses an httpOnly cookie set by the backend.
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(SCOPE_KEY);
  // Clean up legacy localStorage entries from older versions
  try { localStorage.removeItem(TOKEN_KEY); } catch {}
};

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Inject the currently chosen "operator scope" for google users that can switch
  const scope = sessionStorage.getItem(SCOPE_KEY);
  if (scope && config.method?.toLowerCase() === "get") {
    config.params = { ...(config.params || {}), as_operator: scope };
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/");
    if (err?.response?.status === 401 && !isAuthEndpoint) {
      clearToken();
      if (!window.location.pathname.startsWith("/login")) {
        // Preserve intended destination
        const dest = window.location.pathname + window.location.search;
        window.location.href = `/login?from=${encodeURIComponent(dest)}`;
      }
    }
    return Promise.reject(err);
  }
);

export default api;
